import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import Loading from "../../../components/Loading";
import Data from '../../../../repository';
import { createCouponSchema } from '../../../../validation/schemas';

import styles from '../../../../styles/Admin.module.scss';

function CreateCouponForm() {
	const navigate = useNavigate();
	const [loading, setLoading] = useState(false);
	const [serverError, setServerError] = useState(null);

	const {
		register,
		handleSubmit,
		formState: { errors }
	} = useForm({
		resolver: yupResolver(createCouponSchema),
		defaultValues: {
			name: '',
			code: '',
			percent_off: ''
		}
	});

	const onSubmit = async (data) => {
		setLoading(true);
		setServerError(null);

		try {
			await Data.createCoupon({
				name: data.name,
				code: data.code,
				percent_off: Number(data.percent_off)
			});
			navigate('/admin/coupons');
		} catch (error) {
			setServerError(error.response?.data?.message || 'Failed to create coupon. Please try again.');
			setLoading(false);
		}
	}

	return (
		<form onSubmit={handleSubmit(onSubmit)} className={styles.form}>
			<div>
				<p>Name: *</p>
				<input
					type="text"
					{...register('name')}
					className={errors.name ? 'input-error' : ''}
				/>
				{errors.name && <span className="form-field-error">{errors.name.message}</span>}
			</div>

			<div>
				<p>Code: *</p>
				<input
					type="text"
					{...register('code')}
					className={errors.code ? 'input-error' : ''}
				/>
				{errors.code && <span className="form-field-error">{errors.code.message}</span>}
			</div>

			<div>
				<p>Percentage Off: *</p>
				<input
					type="number"
					{...register('percent_off')}
					min={0}
					max={100}
					className={errors.percent_off ? 'input-error' : ''}
				/>
				{errors.percent_off && <span className="form-field-error">{errors.percent_off.message}</span>}
			</div>

			{serverError && <p style={{ color: 'red' }}>{serverError}</p>}

			<button type="submit" className="btn btnPrimary" disabled={loading}>
				{loading ?
					<Loading button={true} />
					:
					`Create Coupon`
				}
			</button>
		</form>
	)
}

export default CreateCouponForm;
